const isObjectEmpty = (obj) => {
  if (typeof obj !== 'object' || obj === null) return true;
  return Object.keys(obj).length === 0;
};

module.exports = isObjectEmpty;
